var _excluded = ["development", "agencies"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { InfoBox } from './info-box';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var ProjectEntityInfo = _ref => {
  var development = _ref.development,
    agencies = _ref.agencies,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var builder = development.builder,
    developer = development.developer;
  if (!developer && !builder && !agencies) {
    return null;
  }
  return ___EmotionJSX(Fragment, null, developer && ___EmotionJSX(InfoBox, _extends({}, developer, {
    entityName: developer.name,
    type: "developer",
    link: developer.url
  }, otherProps)), builder && ___EmotionJSX(InfoBox, _extends({}, builder, {
    entityName: builder.name,
    type: "builder"
  })), agencies.map(agency => {
    var _agency$images;
    return ___EmotionJSX(InfoBox, _extends({}, agency, {
      logo: (_agency$images = agency.images) === null || _agency$images === void 0 ? void 0 : _agency$images.tinyLogo,
      type: "sales team",
      entityName: agency.name
    }));
  }));
};
ProjectEntityInfo.propTypes = {
  development: PropTypes.shape({
    builder: PropTypes.shape({
      name: PropTypes.string
    }),
    developer: PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string
    })
  }),
  agencies: PropTypes.arrayOf(PropTypes.shape({
    images: PropTypes.shape({
      tinyLogo: PropTypes.string
    })
  }))
};
ProjectEntityInfo.defaultProps = {
  development: {},
  agencies: []
};